import { CalendarDays, Clock, Mail, Scale, Sparkles, TrendingUp } from 'lucide-react';

/** The icon of each insight category (the quick-filter id); an unknown one degrades. */
export const INSIGHT_CATEGORY_ICONS = Object.freeze({
  channel: Mail,
  timing: Clock,
  how_they_decide: Scale,
  deal_outlook: TrendingUp,
  scheduling: CalendarDays,
});

export const iconForInsightCategory = (category) => INSIGHT_CATEGORY_ICONS[category] ?? Sparkles;
